
const translations = {
  // Navbar
  "nav.home": "Home",
  "nav.destinations": "Destinations",
  "nav.bookings": "Bookings",
  "nav.testimonials": "Reviews",
  "nav.blog": "Blog",
  "nav.prices": "Rates",
  "nav.contact": "Contact",
  
  // Hero
  "hero.badge": "Premium Service in Fuerteventura",
  "hero.title1": "Discover",
  "hero.title2": "Fuerteventura",
  "hero.title3": "In Style",
  "hero.description": "Experience the luxury of traveling across the island with our exclusive premium transport service. High-end vehicles, professional chauffeurs and personalized attention.",
  "hero.bookNow": "Book Now",
  "hero.viewDestinations": "View Destinations",
  
  // Destinos
  "destinations.title": "Exclusive Destinations",
  "destinations.subtitle": "Discover the most select corners of Fuerteventura with our luxury transport service",
  "destinations.from": "From",
  "destinations.duration": "Duration",
  "destinations.book": "Book",
  
  // Reservas
  "bookings.title": "Book Your Trip",
  "bookings.subtitle": "Complete the form and confirm your premium booking in minutes",
  "bookings.origin": "Origin",
  "bookings.destination": "Destination",
  "bookings.date": "Date",
  "bookings.time": "Time",
  "bookings.passengers": "Passengers",
  "bookings.name": "Full name",
  "bookings.email": "Email address",
  "bookings.phone": "Phone",
  "bookings.submit": "Confirm Booking",
  "bookings.selectOrigin": "Select origin",
  "bookings.selectDestination": "Select destination",
  
  // Testimonios
  "testimonials.title": "Select Client Reviews",
  "testimonials.subtitle": "Over 5,000 distinguished travelers trust us",
  "testimonials.verified": "Verified",
  
  // Servicios
  "services.title": "Premium Services",
  "services.subtitle": "Excellence and distinction in every journey",
  "services.vehicles": "Luxury Fleet",
  "services.vehiclesDesc": "Mercedes V and E Class with leather interior, premium climate control and high-speed WiFi",
  "services.drivers": "Professional Chauffeurs",
  "services.driversDesc": "Highly qualified staff with protocol training and VIP attention",
  "services.punctuality": "Guaranteed Punctuality",
  "services.punctualityDesc": "Absolute commitment to your time. Real-time GPS tracking",
  "services.support": "24/7 Concierge",
  "services.supportDesc": "Personal assistance service available 24 hours a day",
  
  // Precios
  "prices.title": "Premium Rates",
  "prices.subtitle": "Transparency and exclusivity in every service",
  "prices.popular": "Recommended",
  "prices.book": "Book",
  
  // Blog
  "blog.title": "Fuerteventura Guide",
  "blog.subtitle": "Discover the best kept secrets of the island",
  "blog.readMore": "Read more",
  
  // Contacto
  "contact.title": "Contact",
  "contact.subtitle": "At your service",
  "contact.name": "Name",
  "contact.email": "Email",
  "contact.message": "Message",
  "contact.send": "Send Message",
  "contact.address": "Address",
  "contact.phone": "Phone",
  "contact.hours": "Hours",
  "contact.hoursValue": "24/7 Service",
  
  // Footer
  "footer.destinations": "Destinations",
  "footer.services": "Services",
  "footer.information": "Information",
  "footer.legal": "Legal",
  "footer.onlineBookings": "Online Bookings",
  "footer.rates": "Rates",
  "footer.reviews": "Reviews",
  "footer.travelGuide": "Travel Guide",
  "footer.aboutUs": "About Us",
  "footer.faq": "FAQ",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms and Conditions",
  "footer.cookies": "Cookie Policy",
  "footer.legalNotice": "Legal Notice",
  "footer.since": "Since 2010",
  "footer.rights": "All rights reserved."
};

export default translations;
